<template>
  <div class="identity banxin">
    <div class="flex">
      <div
        v-for="(item,index) in info"
        :key="index"
        class="item wow fadeInUp"
        :data-wow-delay="200 + index * 50 + 'ms'"
      >
        <img :src="item.smallImg" alt />
        <h5 class="p1">{{ item.name }}</h5>
        <p>{{ item.title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["info"],
  name: "identity"
};
</script>

<style lang="less" scoped>
.identity {
  margin-top: 40px;

  .sub-title {
    max-width: 1000px;
    padding: 0 20px;
    margin: 0px auto 70px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: rgba(102, 107, 128, 1);
    line-height: 26px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .item {
      width: 30%;
      background-color: #fff;
      padding: 30px;

      img {
        width: 70px;
        height: 70px;
        margin: 0 auto;
        margin-bottom: 10px;
      }

      .p1 {
        font-size: 20px;
        font-weight: 600;
        color: rgba(32, 38, 64, 1);
        line-height: 28px;
        text-align: center;
        margin-bottom: 20px;
      }

      p {
        // padding: 30px 20px 38px 20px;
        font-size: 16px;
        font-weight: 400;
        color: rgba(32, 38, 64, 1);
        line-height: 26px;
      }
    }
  }
}

@media (max-width: 1024px) {
}

@media (max-width: 768px) {
  .banxin {
    padding: 0;
  }
  .identity {
    .sub-title {
      max-width: 1000px;
      padding: 0 20px;
      margin: 0px auto 70px;
      text-align: center;
      font-size: 14px;
      font-weight: 400;
      color: rgba(102, 107, 128, 1);
      line-height: 26px;
    }

    .flex {
      display: block;
      justify-content: space-between;

      .item {
        width: 100%;
        background-color: #fff;
        margin-bottom: 10px;

        p {
          font-size: 16px;
          font-weight: 400;
          color: rgba(32, 38, 64, 1);
          line-height: 26px;
        }
      }
    }
  }
}
</style>
